import React from 'react';

import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

const TextBday = () => {
  const { t } = useTranslation();

  return (
    <div data-bem="TextBday">
      {S.space}
      <div className="bottom-text">
        <span>{t('clientConnect.sectionsDescriptionPart1')}</span> {t('clientConnect.section9DescriptionPart2')}
      </div>
    </div>
  );
};

export default TextBday;
